import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class SelectedCardActions extends Actions{
    static get target(){
        return 'selectedCard'
    }

    static clear(){
        this.set({})
    }
}


// WEBPACK FOOTER //
// ./actions/SelectedCardActions.js